import React from 'react';

import codeSplitComponentFactory from '../../../../common/codeSplitComponentFactory';

const AtlassianSupportsUkraineSplit = codeSplitComponentFactory(() =>
  import(/* webpackChunkName: "chunk-support-ukraine-details" */ './AtlassianSupportsUkraineRoute').then(
    c => c.default
  )
);

export default function AtlassianSupportsUkraineRouteHandler() {
  return <AtlassianSupportsUkraineSplit />;
}
